import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholderConfluence: {
		id: 'backlog.card-list.inline-card-create.ai-work-create.placeholder-with-link-picker.placeholder-confluence',
		defaultMessage: 'Describe what needs to be done, or <link>search Confluence</link>.',
		description:
			'Text for inline card create placeholder, tells user to input their summary or to search Confluence.',
	},
	placeholderConfluenceAndLoom: {
		id: 'backlog.card-list.inline-card-create.ai-work-create.placeholder-with-link-picker.placeholder-confluence-and-loom',
		defaultMessage:
			'Describe what needs to be done, or generate work items from <link>Confluence or Loom</link>.',
		description:
			'Text for inline card create placeholder, tells user to input their summary or to generate work items from Confluence or Loom.',
	},
});
